import { Radio, Table, Tooltip } from 'antd'
import errAnnouceApi from 'api/errAnnouceApi'
import invoiceApi from 'api/invoiceApi'
import { setAppSpinning } from 'app/appSlice'
import customSelectTableCellStyle from 'assets/styles/customSelectTableCellStyle'
import dayjs from 'dayjs'
import TaxCodeDisplay from 'features/Invoice/screens/CreateInvoice/Components/TaxCodeDisplay'
import { useFormik } from 'formik'
import CustomButton from 'general/components/Button/CustomButton'
import InvoiceFooter from 'general/components/eInvoiceComponents/AppFooter/InvoiceFooter'
import BaseTextFieldNoFormik from 'general/components/Forms/BaseTextFieldNoFormik'
import FindInvoiceModal from 'general/components/Modal/FindInvoiceModal'
import {
  ACTION_TYPE,
  ANNOUCEMENT_METHOD,
  ANNOUNCEMENT_TYPE,
  INVOICE_APPLY_TYPE,
  INVOICE_TYPE_TO_QUERY,
} from 'general/constants/AppConstants'
import SelectOptions from 'general/constants/SelectOptions'
import ToastHelper from 'general/helpers/ToastHelper'
import moment from 'moment'
import { useEffect, useMemo, useState } from 'react'
import DatePicker from 'react-datepicker'
import { useDispatch, useSelector } from 'react-redux'
import { useNavigate, useParams, useSearchParams } from 'react-router-dom'
import Select from 'react-select'
import { createErrAnnouce } from './Functions/createErrAnnouce'
import { updateErrAnnouce } from './Functions/updateErrAnnouce'
import './style.scss'
import InvoiceHelper from 'general/helpers/InvoiceHelper'
import { setTaxCode } from 'general/utils/Utils'

var submitAction
function ErrorAnnouncement() {
  const dispatch = useDispatch()
  const { errAnnouceId, invoiceIds, invoiceInfo } = useParams()
  const navigate = useNavigate()
  const [searchParam] = useSearchParams()

  const invoiceClassify = searchParam.get('invoiceClassify')

  const today = new Date()

  const { currentAccount } = useSelector((state) => state?.auth)
  const { company } = useSelector((state) => state?.system)

  const [findInvoiceModalShow, setFindInvoiceModalShow] = useState(false)
  const [errAnnouceInfo, setErrAnnouceInfo] = useState({})
  const [errAnnouceCustomerNo, setErrAnnouceCustomerNo] = useState('TBSS')
  const [tableData, setTableData] = useState([])
  const [actionType, setActionType] = useState('')
  const [isInternal, setIsInternal] = useState(true)
  const [inforActionSaveAndSign, setInforActionSaveAndSign] = useState({
    disabled: false,
  })
  // const [showNoRight, setShowNoRight] = useState(false)
  // const listFunction = useSelector((state) => state?.function?.listFunctions)
  // const userFunction = useSelector((state) => state?.function?.userFunctions)
  // const [isCreateCancelInvoice] = useMemo(() => {
  //   return Utils.checkFunction(
  //     [
  //       {
  //         listFunctionCode: 'INVOICE_CREATE_CANCEL_INVOICE',
  //       },
  //     ],
  //     userFunction,
  //     listFunction,
  //   )
  // }, [userFunction, listFunction])

  const fetchTotalErrAnnouce = async () => {
    try {
      const res = await errAnnouceApi.getTotal()
      if (res.result === 'success') {
        setErrAnnouceCustomerNo(`TBSS${res.count}`)
      }
    } catch (err) {
      console.log(err)
    }
  }

  const fetchErrAnnouceInfo = async () => {
    try {
      const res = await errAnnouceApi.list({ errAnnouceId })
      if (res?.result === 'success') {
        setErrAnnouceInfo(res?.rows[0])
        setValueRadioButton(res?.rows[0]?.type)
        let invoices = res?.rows[0]?.invoices
        invoices?.map((invoice, index) => {
          invoice.STT = index + 1
        })
        setTableData(invoices)
        setErrAnnouceCustomerNo(res?.rows[0]?.customerNo)
      }
    } catch (err) {
      ToastHelper.showError('Có lỗi khi lấy thông tin thông báo')
      navigate('/hoa-don-dau-ra/xu-ly-hoa-don/danh-sach-thong-bao-sai-sot')
    }
  }

  useEffect(() => {
    const pathname = window.location.pathname
    const parts = pathname.split('/')
    if (parts.includes('thong-bao-sai-sot-khac-he-thong')) {
      setIsInternal(false)
    }
  }, [])

  useEffect(() => {
    if (invoiceIds) {
      const invoiceIdsArray = invoiceIds.split(',')
      fetchInvoiceData(invoiceIdsArray, invoiceClassify)
    }
  }, [invoiceIds, invoiceClassify])

  useEffect(() => {
    if (invoiceInfo) {
      const paramsArray = invoiceInfo.split('&')
      const jsonInvoice = { STT: 1 }

      paramsArray.forEach((param) => {
        const [key, value] = param.split('=')
        jsonInvoice[key] = value
      })

      setTableData([jsonInvoice])
    }
  }, [invoiceInfo])

  useEffect(() => {
    if (errAnnouceId) {
      fetchErrAnnouceInfo()
    }
  }, [errAnnouceId])

  useEffect(() => {
    const pathname = window.location.pathname
    const parts = pathname.split('/')
    if (parts.includes('chinh-sua-thong-bao-sai-sot')) {
      setActionType(ACTION_TYPE.UPDATE)
    } else {
      setActionType(ACTION_TYPE.CREATE)
      fetchTotalErrAnnouce()
    }
  }, [])

  const resetButtonSaveAndSign = () => {
    if (submitAction == 'SaveAndSign') {
      setInforActionSaveAndSign({ disabled: false })
    }
  }

  const formik = useFormik({
    initialValues: {
      customerNo: errAnnouceCustomerNo ?? '',
      taxPayerName: errAnnouceInfo?.taxPayerName ?? company?.companyName,
      taxCode: setTaxCode(errAnnouceInfo?.taxCode ?? company?.taxCode, company),
      taxAuthorityId: company?.taxAuthority?.code ?? 70127,
      taxAuthorityName:
        errAnnouceInfo?.taxAuthorityName ?? company?.taxAuthority?.name,
      type: errAnnouceInfo?.type ?? 1,
      place: errAnnouceInfo?.place ?? company?.province?.name,
      date:
        errAnnouceInfo?.date?.slice(0, 10) ??
        moment(today).format('YYYY-MM-DD'),
      taxAuthorityReviewNo: errAnnouceInfo?.taxAuthorityReviewNo ?? '',
      taxAuthorityReviewDate:
        errAnnouceInfo?.taxAuthorityReviewDate ??
        moment(today).format('YYYY-MM-DD'),
      errorAnnoucementId: errAnnouceInfo?.errorAnnoucementId ?? null,

      invoiceClassify: errAnnouceInfo?.invoiceClassify ?? invoiceClassify,
    },
    // validationSchema,
    onSubmit: async (values) => {
      if (!values?.place) {
        ToastHelper.showError('Vui lòng nhập nơi lập thông báo')
        resetButtonSaveAndSign({ disabled: false })
        return
      }
      let choosenInvoiceIds = [],
        isNotValidate = false
      tableData.forEach((invoice) => {
        choosenInvoiceIds.push(invoice.invoiceId)

        //set Hình thức thông báo ăn Theo loại thông báo 6/Thông báo 4/Giải trình
        invoice.errAnnouceType =
          values?.type == ANNOUNCEMENT_TYPE.NNT_NOTICE
            ? ANNOUCEMENT_METHOD.NOTICE
            : ANNOUCEMENT_METHOD.EXPLAINED
      })
      if (isNotValidate) {
        ToastHelper.showError('Vui lòng điền đầy đủ thông tin cho từng hóa đơn')
        resetButtonSaveAndSign({ disabled: false })
        return
      }

      let signingConfig = {
        signingMethod: company?.activeSigningMethod,
      }
      dispatch(setAppSpinning(true))
      // Hoá đơn trong hệ thống
      if (isInternal) {
        switch (actionType) {
          case ACTION_TYPE.CREATE:
            createErrAnnouce(
              company,
              choosenInvoiceIds,
              submitAction,
              tableData,
              values,
              dispatch,
              setAppSpinning,
              navigate,
              signingConfig,
              resetButtonSaveAndSign,
            )

            break
          case ACTION_TYPE.UPDATE:
            updateErrAnnouce(
              submitAction,
              tableData,
              values,
              dispatch,
              setAppSpinning,
              navigate,
              currentAccount,
              signingConfig,
              resetButtonSaveAndSign,
            )

            break
          default:
            return
        }
      } else {
        switch (actionType) {
          case ACTION_TYPE.CREATE:
            try {
              const res = await invoiceApi.bulkCreateExternal({
                invoices: tableData,
              })
              if (res.result === 'success') {
                const { createInvoiceIds } = res.data

                let _tableData = tableData.map((item, index) => ({
                  ...item,
                  invoiceId: createInvoiceIds?.at(index),
                }))
                createErrAnnouce(
                  company,
                  createInvoiceIds,
                  submitAction,
                  _tableData,
                  values,
                  dispatch,
                  setAppSpinning,
                  navigate,
                  signingConfig,
                  resetButtonSaveAndSign,
                )
              }
            } catch (err) {
              console.log(err)
            }
            break
          case ACTION_TYPE.UPDATE:
            updateErrAnnouce(
              submitAction,
              tableData,
              values,
              dispatch,
              setAppSpinning,
              navigate,
              undefined,
              signingConfig,
              resetButtonSaveAndSign,
            )

            break
          default:
            return
        }
      }
    },
    enableReinitialize: true,
    validateOnChange: false,
  })

  const fetchInvoiceData = async (invoiceIdsArray, invoiceClassify) => {
    try {
      let res = await invoiceApi.listAll({
        invoiceIdsArray,
        classify: invoiceClassify,
      })
      if (res?.result === 'success') {
        res?.rows.map((item, index) => {
          item.STT = index + 1
        })
        setTableData(res?.rows)
      } else {
        ToastHelper.showError('Không tìm thấy thông tin hoá đơn')
      }
    } catch (err) {
      console.log(err)
    }
  }

  const FormLabel = (props) => {
    return (
      <div
        className=" font-weight-normal d-flex align-items-center"
        style={{ width: props.width ?? '220px' }}
      >
        {props.children}
      </div>
    )
  }

  const handleRemoveRow = (row) => {
    let newTableData = tableData.filter((item) => item.STT !== row.STT)

    for (let i = 0; i < newTableData.length; i++) {
      newTableData[i].STT = i + 1
    }
    setTableData(newTableData)
  }

  const [valueRadioButton, setValueRadioButton] = useState(formik.values.type)

  const onChangeRadioButton = (e) => {
    // debugger
    setValueRadioButton(e.target.value)
    formik.setFieldValue('type', e.target.value)

    if (e.target.value === 1) {
      formik.setFieldValue('taxAuthorityReviewNo', '')
      formik.setFieldValue(
        'taxAuthorityReviewDate',
        moment(today).format('YYYY-MM-DD'),
      )
    }
  }

  const handleChangeTableData = (STT, fieldName, data) => {
    let newTableData = [...tableData]
    newTableData[STT - 1][fieldName] = data
    setTableData(newTableData)
  }

  const columns = useMemo(() => {
    let ret = [
      {
        title: 'STT',
        dataIndex: 'no',
        key: '1',
        width: 60,
        render: (_, row) => (
          <p
            data-tag="allowRowEvents"
            className="d-flex justify-content-center font-weight-normal m-2 text-maxline-3 "
          >
            {row?.STT}
          </p>
        ),
      },
      {
        title: 'Mã CQT cấp',
        dataIndex: 'taxAuthorityCode',
        key: 'taxAuthorityCode',
        width: 200,
        render: (_, row) => {
          const text = row?.taxAuthorityCode
          return (
            <Tooltip title={text}>
              <p
                style={{ maxWidth: '200px' }}
                data-tag="allowRowEvents"
                className="d-flex justify-content-center font-weight-normal m-2 q-max-line-1 text-maxline-3"
              >
                {text}
              </p>
            </Tooltip>
          )
        },
      },
      {
        title: 'Ký hiệu',
        dataIndex: 'serial',
        key: '3',
        width: 100,
        render: (_, row) => (
          <p
            data-tag="allowRowEvents"
            className="d-flex justify-content-center font-weight-normal m-2 text-maxline-3"
          >
            {row?.serial}
          </p>
        ),
      },
      {
        title: 'Số HĐ',
        dataIndex: 'no',
        key: '4',
        width: 100,
        render: (_, row) => (
          <p
            data-tag="allowRowEvents"
            className="d-flex justify-content-center font-weight-normal m-2 text-maxline-3"
          >
            {row?.no}
          </p>
        ),
      },
      {
        title: 'Ngày HĐ',
        dataIndex: 'date',
        key: '5',
        width: 100,
        render: (_, row) => {
          const date = dayjs(row?.date)
          return (
            <p
              data-tag="allowRowEvents"
              className="d-flex justify-content-center font-weight-normal m-2 text-maxline-3 q-max-line-1"
            >
              {date.isValid() ? date.format('L') : ''}
            </p>
          )
        },
      },
      {
        title: 'Loại áp dụng HĐĐT',
        dataIndex: 'invoiceApplyType',
        key: '5',
        width: 200,
        render: (_, row) => {
          const text = InvoiceHelper.getInvoiceApplyType(
            INVOICE_APPLY_TYPE.ELECTRONIC_123_2020,
          )
          return (
            <Tooltip title={text}>
              <p
                data-tag="allowRowEvents"
                className="d-flex justify-content-center font-weight-normal m-2 q-max-line-1 text-maxline-3"
              >
                {text}
              </p>
            </Tooltip>
          )
        },
      },
      {
        title: <span>Thông báo/ Giải trình</span>,
        key: '6',
        width: 250,
        render: (_, row) => (
          <p className="m-2">
            {InvoiceHelper.getAnnouncementText(formik.values.type)}
          </p>
        ),
      },
      {
        title: <span>Lý do</span>,
        key: '4',
        width: 180,

        render: (_, row) => (
          <div
            className="w-100 input-table-cover"
            style={{
              minWidth: '250px',
            }}
          >
            <BaseTextFieldNoFormik
              onChange={(e) => {
                handleChangeTableData(
                  row.STT,
                  'errAnnouceReason',
                  e.target.value,
                )
              }}
              showBorder={false}
              inputValue={row?.errAnnouceReason}
              // disabled={row?.type === 4 ? true : false}
              rounded={row?.type === 4 ? false : true}
              transparent={row?.type === 4 ? false : true}
              // multiLine={true}
            />
          </div>
        ),
      },
      {
        title: '',
        dataIndex: 'option',
        key: 'option',
        width: 50,
        align: 'center',
        render: (_, row) => (
          <div className="d-flex justify-content-center">
            <div
              className="d-flex h-100 align-items-center cursor-pointer h-100 icon-table"
              style={{ zIndex: '1' }}
              onClick={() => {
                if (tableData.length !== 1) {
                  handleRemoveRow(row)
                }
              }}
            >
              <i className="far fa-trash" style={{ color: 'red' }}></i>
            </div>
          </div>
        ),
      },
    ]

    return ret
  }, [tableData, formik.values.type])

  return (
    <>
      <div className="d-flex justify-content-start container-xxl mt-5">
        <label style={{ fontSize: 24, fontWeight: '700', color: 'black' }}>
          Lập thông báo HĐ lập sai
        </label>
      </div>
      <div className="error-announce-cover font-sfpro-regular">
        <div className="error-announce">
          <div className="d-flex flex-column align-items-center">
            <h4
              className="invoice-title font-weight-boldest"
              style={{ letterSpacing: '1px' }}
            >
              CỘNG HÒA XÃ HỘI CHỦ NGHĨA VIỆT NAM
            </h4>
            <h4
              className="invoice-title font-weight-boldest"
              style={{ letterSpacing: '1px' }}
            >
              Độc lập - Tự do - Hạnh phúc
            </h4>
          </div>
          <div className="d-flex flex-column align-items-center my-3">
            <h4
              className=""
              style={{ fontWeight: '600', letterSpacing: '0.5px' }}
            >
              THÔNG BÁO HÓA ĐƠN ĐIỆN TỬ ĐÃ LẬP SAI
            </h4>
            <div className="d-flex flex-row  flex-grow-1 align-content-center mt-2">
              <FormLabel width="100px">Số thông báo:</FormLabel>
              <div>
                <input
                  type="text"
                  className="form-control input-dot"
                  // readOnly={screenAction == 'xem'}
                  value={formik.values.customerNo}
                  onChange={(e) =>
                    formik.setFieldValue('customerNo', e.target.value)
                  }
                  required
                />
              </div>
            </div>
          </div>
          <div className="d-flex flex-column" style={{ gap: '12px' }}>
            <div className="d-flex flex-row w-100">
              <FormLabel>Loại thông báo:</FormLabel>
              <Radio.Group
                onChange={onChangeRadioButton}
                value={valueRadioButton}
              >
                <Radio value={1}>Thông báo của NNT</Radio>
                <Radio value={2}>
                  Giải trình của NNT theo thông báo rà soát của CQT
                </Radio>
              </Radio.Group>
            </div>
            {valueRadioButton == 2 && (
              <div className="d-flex flex-row  w-100">
                <div className="d-flex flex-row  flex-grow-1 align-content-center">
                  <FormLabel width="220px">
                    Số thông báo rà soát của CQT:
                  </FormLabel>
                  <div>
                    <input
                      type="text"
                      className="form-control input-dot"
                      // readOnly={screenAction == 'xem'}
                      value={formik.values.taxAuthorityReviewNo}
                      onChange={(e) =>
                        formik.setFieldValue(
                          'taxAuthorityReviewNo',
                          e.target.value,
                        )
                      }
                      required
                    />
                  </div>
                </div>
                <div className="d-flex flex-row  flex-grow-1 align-content-center">
                  <FormLabel width="230px">
                    Ngày thông báo rà soát của CQT:
                  </FormLabel>
                  <div>
                    <DatePicker
                      dateFormat="dd/MM/yyyy"
                      customInput={
                        <input
                          type="text"
                          className="form-control input-dot input-date"
                        />
                      }
                      todayButton={<button>Hôm nay</button>}
                      // readOnly={screenAction == 'xem'}
                      selected={new Date(formik.values.taxAuthorityReviewDate)}
                      // selected={new Date(registration.date) || new Date()}
                      onChange={(date) => {
                        formik.setFieldValue(
                          'taxAuthorityReviewDate',
                          dayjs(date).format('YYYY-MM-DD HH:mm:ss'),
                        )
                      }}
                    />
                  </div>
                </div>
              </div>
            )}
            <div className="d-flex flex-row w-100">
              <FormLabel>Cơ quan thuế tiếp nhận:</FormLabel>
              <span className="">{formik.values.taxAuthorityName}</span>
            </div>
            <div className="d-flex flex-row  w-100">
              <FormLabel>Tên người nộp thuế:</FormLabel>
              <span className="">{formik.values.taxPayerName}</span>
            </div>
            <div className="d-flex flex-row  w-100">
              <FormLabel>Mã số thuế:</FormLabel>
              <TaxCodeDisplay taxCode={formik.values?.taxCode} />
            </div>
          </div>
          <div className="mt-5 d-flex flex-row justify-content-between mb-5">
            <span>
              Người nộp thuế thông báo về việc hóa đơn điện tử có sai sót như
              sau:
            </span>
          </div>
          <Table
            dataSource={tableData}
            columns={columns}
            bordered
            checkbox
            pagination={false}
            // rowSelection={currentTab === 0 ? rowSelection : false}
            scroll={{
              x: 1100,
            }}
          />
          <CustomButton
            text="Thêm mới"
            color="#304FFD"
            backgroundColor="transparent"
            width="120px"
            showBorder={false}
            icon={'fal fa-plus'}
            gap="5px"
            className="mt-2"
            onClick={() => {
              setFindInvoiceModalShow(true)
            }}
          />
          <div
            className="d-flex flex-column mt-5"
            style={{ gap: '10px', width: '350px' }}
          >
            <div className="d-flex flex-row align-items-center">
              <FormLabel width="250px">Nơi lập:</FormLabel>
              <div>
                <input
                  type="text"
                  className="form-control input-dot"
                  // readOnly={screenAction == 'xem'}
                  value={formik.values.place}
                  onChange={(e) =>
                    formik.setFieldValue('place', e.target.value)
                  }
                  required
                />
              </div>
              {/* <BaseTextField
                name="place"
                fieldProps={formik.getFieldProps('place')}
                fieldMeta={formik.getFieldMeta('place')}
                fieldHelper={formik.getFieldHelpers('place')}
                className="w-100"
              /> */}
            </div>

            <div className="d-flex flex-row align-items-center mt-4">
              <FormLabel width="200px">Ngày lập thông báo:</FormLabel>
              {/* <BaseTextField className="w-100" /> */}
              <div>
                <DatePicker
                  dateFormat="dd/MM/yyyy"
                  customInput={
                    <input
                      type="text"
                      className="form-control input-dot input-date"
                    />
                  }
                  todayButton={<button>Hôm nay</button>}
                  // readOnly={screenAction == 'xem'}
                  selected={
                    formik.values.date ? new Date(formik.values.date) : null
                  }
                  // selected={new Date(registration.date) || new Date()}
                  onChange={(date) => {
                    if (date) {
                      formik.setFieldValue(
                        'date',
                        dayjs(date).format('YYYY-MM-DD HH:mm:ss'),
                      )
                    } else {
                      formik.setFieldValue('date', null)
                    }
                  }}
                />
              </div>
              {/* <div className="">
                <KTFormInput
                  name="1"
                  value={formik.getFieldProps('date').value}
                  onChange={(value) => {
                    formik.setFieldValue('date', value);
                  }}
                  onFocus={() => {
                    formik.setFieldTouched('date', true);
                  }}
                  enableCheckValid
                  // isValid={_.isEmpty(meta.error)}
                  // isTouched={meta.touched}
                  // feedbackText={meta.error}
                  type={KTFormInputType.date}
                  // disabled={!canEdit}
                />
              </div> */}
            </div>
          </div>
          <div className="d-flex w-100 justify-content-between mt-15">
            <div
              className="d-flex flex-column align-items-center"
              style={{ marginLeft: '100px' }}
            >
              <span style={{ height: '21px', width: '21px' }}></span>
              <h5 style={{ fontWeight: '600', marginTop: '6.5px' }}>
                NGƯỜI MUA
              </h5>
              <span style={{ fontWeight: '400' }}>
                (Chữ ký số của người mua nếu có)
              </span>
              <div style={{ height: '200px' }}></div>
            </div>
            <div
              className="d-flex flex-column align-items-center"
              style={{ marginRight: '100px' }}
            >
              <span style={{ fontSize: '14px' }}>
                {formik.values?.place}, ngày{' '}
                {moment(formik.values?.date).date()} tháng{' '}
                {moment(formik.values?.date).month() + 1} năm{' '}
                {moment(formik.values?.date).year()}
              </span>
              <h5 className="mt-2" style={{ fontWeight: '600' }}>
                NGƯỜI NỘP THUẾ
              </h5>
              <span style={{ fontWeight: '400' }}>
                (Chữ ký số, chữ ký điện tử của người nộp thuế)
              </span>
              <div style={{ height: '200px' }}></div>
            </div>
          </div>
        </div>
        <FindInvoiceModal
          show={findInvoiceModalShow}
          onHide={() => setFindInvoiceModalShow(false)}
          title="Chọn hoá đơn sai sót"
          invoiceType={INVOICE_TYPE_TO_QUERY.CAN_ERR_ANNOUCED}
          buttonAgreeOnlick={(selectedInvoices) => {
            for (let i = 0; i < selectedInvoices.length; i++) {
              for (let j = 0; j < tableData.length; j++) {
                if (selectedInvoices[i].invoiceId === tableData[j].invoiceId) {
                  ToastHelper.showError(
                    `Hoá đơn kí hiệu ${selectedInvoices[i].serial}, số  ${selectedInvoices[i].no} đã được chọn`,
                  )
                  return
                }
              }
            }
            const newTableData = [...tableData, ...selectedInvoices]
            newTableData.map((invoice, index) => {
              invoice.STT = index + 1
              // invoice.errAnnouceType = 1
            })
            setTableData(newTableData)
            setFindInvoiceModalShow(false)
          }}
          buttonAgreeTab2Onlick={(selectedInvoice) => {
            const newTableData = [...tableData, selectedInvoice]
            newTableData.map((invoice, index) => {
              invoice.STT = index + 1
            })
            setTableData(newTableData)
            setFindInvoiceModalShow(false)
          }}
          buttonAgreeVisibility={true}
          checkBoxShow={false}
          selectableRows={true}
          showTab={false}
          defaultTab={isInternal ? 0 : 1}
        />
        <InvoiceFooter
          // buttonCancel={true}
          // buttonPrint={true}
          buttonCancel={true}
          buttonCancelOnClick={() => {
            navigate(
              '/hoa-don-dau-ra/xu-ly-hoa-don/danh-sach-thong-bao-sai-sot',
            )
          }}
          buttonCreate={true}
          buttonSaveAndSign={true}
          buttonSaveAndSignOnClick={() => {
            setInforActionSaveAndSign({ disabled: true })
            submitAction = 'SaveAndSign'
            formik.handleSubmit()
          }}
          buttonCreateOnClick={() => {
            submitAction = 'Save'
            // console.log(tableData);
            formik.handleSubmit()
          }}
          inforActionSaveAndSign={inforActionSaveAndSign}
          setInforActionSaveAndSign={setInforActionSaveAndSign}
        />
        {/* <ModalUnauthorized show={showNoRight} setShow={setShowNoRight} /> */}
      </div>
    </>
  )
}

export default ErrorAnnouncement
